var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrande(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 584,
    height: 606,
    viewBox: "0 0 584 606",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M423.355 435.442L292.18 511.177V167.649L423.355 91.9141V435.442Z",
    fill: "#5C93F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M306.099 183.832L299.727 187.512V171.957L306.099 168.277V183.832Z",
    fill: "#C2CDDD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M409.445 124.164L415.817 120.486V104.93L409.445 108.609V124.164Z",
    fill: "#C2CDDD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M320.02 175.797L313.648 179.476V163.921L320.02 160.242V175.797Z",
    fill: "#C2CDDD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M327.692 171.365L321.32 175.043V159.488L327.692 155.809V171.365Z",
    fill: "#C2CDDD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M335.372 166.934L329 170.612V155.056L335.372 151.379V166.934Z",
    fill: "#C2CDDD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M353.286 156.59L346.914 160.269V144.714L353.286 141.035V156.59Z",
    fill: "#C2CDDD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M360.958 152.158L354.586 155.836V140.281L360.958 136.602V152.158Z",
    fill: "#C2CDDD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M368.638 147.727L362.266 151.405V135.851L368.638 132.172V147.727Z",
    fill: "#C2CDDD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M386.551 137.383L380.18 141.062V125.507L386.551 121.828V137.383Z",
    fill: "#C2CDDD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M394.223 132.95L387.852 136.629V121.074L394.223 117.395V132.95Z",
    fill: "#C2CDDD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M401.904 128.52L395.531 132.198V116.643L401.904 112.965V128.52Z",
    fill: "#C2CDDD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M306.099 208.649L299.727 212.327V196.772L306.099 193.094V208.649Z",
    fill: "#C2CDDD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M409.445 148.98L415.817 145.301V129.746L409.445 133.425V148.98Z",
    fill: "#C2CDDD"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M320.02 200.612L313.648 204.292V188.736L320.02 185.059V200.612Z",
    fill: "#C2CDDD"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M327.692 196.18L321.32 199.859V184.304L327.692 180.625V196.18Z",
    fill: "#C2CDDD"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M335.372 191.75L329 195.429V179.874L335.372 176.195V191.75Z",
    fill: "#C2CDDD"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M353.286 181.407L346.914 185.085V169.53L353.286 165.852V181.407Z",
    fill: "#C2CDDD"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M360.958 176.973L354.586 180.652V165.097L360.958 161.418V176.973Z",
    fill: "#C2CDDD"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M368.638 172.542L362.266 176.222V160.667L368.638 156.988V172.542Z",
    fill: "#C2CDDD"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M386.551 162.2L380.18 165.878V150.323L386.551 146.645V162.2Z",
    fill: "#C2CDDD"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M394.223 157.767L387.852 161.446V145.891L394.223 142.211V157.767Z",
    fill: "#C2CDDD"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M401.904 153.335L395.531 157.015V141.459L401.904 137.781V153.335Z",
    fill: "#C2CDDD"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M306.099 233.466L299.727 237.144V221.59L306.099 217.91V233.466Z",
    fill: "#C2CDDD"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M409.445 173.796L415.817 170.119V154.562L409.445 158.242V173.796Z",
    fill: "#C2CDDD"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M320.02 225.43L313.648 229.109V213.554L320.02 209.875V225.43Z",
    fill: "#C2CDDD"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M327.692 220.998L321.32 224.675V209.121L327.692 205.441V220.998Z",
    fill: "#C2CDDD"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M335.372 216.567L329 220.246V204.69L335.372 201.012V216.567Z",
    fill: "#C2CDDD"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M353.286 206.222L346.914 209.902V194.347L353.286 190.668V206.222Z",
    fill: "#C2CDDD"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M360.958 201.79L354.586 205.468V189.914L360.958 186.234V201.79Z",
    fill: "#C2CDDD"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M368.638 197.36L362.266 201.039V185.483L368.638 181.805V197.36Z",
    fill: "#C2CDDD"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M386.551 187.015L380.18 190.695V175.138L386.551 171.461V187.015Z",
    fill: "#C2CDDD"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M394.223 182.582L387.852 186.261V170.707L394.223 167.027V182.582Z",
    fill: "#C2CDDD"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M401.904 178.153L395.531 181.831V166.276L401.904 162.598V178.153Z",
    fill: "#C2CDDD"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M306.099 258.282L299.727 261.96V246.405L306.099 242.727V258.282Z",
    fill: "#C2CDDD"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M409.445 198.613L415.817 194.934V179.379L409.445 183.058V198.613Z",
    fill: "#C2CDDD"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M320.02 250.242L313.648 253.921V238.366L320.02 234.688V250.242Z",
    fill: "#C2CDDD"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M327.692 245.813L321.32 249.491V233.936L327.692 230.258V245.813Z",
    fill: "#C2CDDD"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M335.372 241.38L329 245.058V229.504L335.372 225.824V241.38Z",
    fill: "#C2CDDD"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M353.286 231.039L346.914 234.718V219.163L353.286 215.484V231.039Z",
    fill: "#C2CDDD"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M360.958 226.61L354.586 230.288V214.733L360.958 211.055V226.61Z",
    fill: "#C2CDDD"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M368.638 222.176L362.266 225.856V210.301L368.638 206.621V222.176Z",
    fill: "#C2CDDD"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M386.551 211.832L380.18 215.511V199.956L386.551 196.277V211.832Z",
    fill: "#C2CDDD"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M394.223 207.403L387.852 211.081V195.525L394.223 191.848V207.403Z",
    fill: "#C2CDDD"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M401.904 202.969L395.531 206.649V191.093L401.904 187.414V202.969Z",
    fill: "#C2CDDD"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M306.099 283.094L299.727 286.773V271.218L306.099 267.539V283.094Z",
    fill: "#C2CDDD"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M409.445 223.429L415.817 219.749V204.195L409.445 207.873V223.429Z",
    fill: "#C2CDDD"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M320.02 275.06L313.648 278.738V263.184L320.02 259.504V275.06Z",
    fill: "#C2CDDD"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M327.692 270.628L321.32 274.308V258.752L327.692 255.074V270.628Z",
    fill: "#C2CDDD"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M335.372 266.196L329 269.874V254.319L335.372 250.641V266.196Z",
    fill: "#C2CDDD"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M353.286 255.857L346.914 259.534V243.981L353.286 240.301V255.857Z",
    fill: "#C2CDDD"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M360.958 251.422L354.586 255.101V239.546L360.958 235.867V251.422Z",
    fill: "#C2CDDD"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M368.638 246.992L362.266 250.671V235.116L368.638 231.438V246.992Z",
    fill: "#C2CDDD"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M386.551 236.649L380.18 240.327V224.773L386.551 221.094V236.649Z",
    fill: "#C2CDDD"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M394.223 232.219L387.852 235.898V220.343L394.223 216.664V232.219Z",
    fill: "#C2CDDD"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M401.904 227.787L395.531 231.464V215.91L401.904 212.23V227.787Z",
    fill: "#C2CDDD"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M306.099 307.913L299.727 311.593V296.037L306.099 292.359V307.913Z",
    fill: "#C2CDDD"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M409.445 248.245L415.817 244.567V229.012L409.445 232.69V248.245Z",
    fill: "#C2CDDD"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M320.02 299.875L313.648 303.554V287.999L320.02 284.32V299.875Z",
    fill: "#C2CDDD"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M327.692 295.443L321.32 299.121V283.566L327.692 279.887V295.443Z",
    fill: "#C2CDDD"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M335.372 291.012L329 294.691V279.136L335.372 275.457V291.012Z",
    fill: "#C2CDDD"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M353.286 280.672L346.914 284.351V268.796L353.286 265.117V280.672Z",
    fill: "#C2CDDD"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M360.958 276.241L354.586 279.921V264.366L360.958 260.688V276.241Z",
    fill: "#C2CDDD"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M368.638 271.81L362.266 275.488V259.933L368.638 256.254V271.81Z",
    fill: "#C2CDDD"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M386.551 261.466L380.18 265.145V249.59L386.551 245.91V261.466Z",
    fill: "#C2CDDD"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M394.223 257.034L387.852 260.714V245.158L394.223 241.48V257.034Z",
    fill: "#C2CDDD"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M401.904 252.602L395.531 256.28V240.726L401.904 237.047V252.602Z",
    fill: "#C2CDDD"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M306.099 332.731L299.727 336.409V320.854L306.099 317.176V332.731Z",
    fill: "#C2CDDD"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M409.445 273.062L415.817 269.383V253.828L409.445 257.507V273.062Z",
    fill: "#C2CDDD"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M320.02 324.696L313.648 328.375V312.819L320.02 309.141V324.696Z",
    fill: "#C2CDDD"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M327.692 320.262L321.32 323.941V308.386L327.692 304.707V320.262Z",
    fill: "#C2CDDD"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M335.372 315.832L329 319.511V303.956L335.372 300.277V315.832Z",
    fill: "#C2CDDD"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M353.286 305.489L346.914 309.167V293.612L353.286 289.934V305.489Z",
    fill: "#C2CDDD"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M360.958 301.056L354.586 304.735V289.18L360.958 285.5V301.056Z",
    fill: "#C2CDDD"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M368.638 296.624L362.266 300.304V284.748L368.638 281.07V296.624Z",
    fill: "#C2CDDD"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M386.551 286.282L380.18 289.96V274.405L386.551 270.727V286.282Z",
    fill: "#C2CDDD"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M394.223 281.849L387.852 285.528V269.973L394.223 266.293V281.849Z",
    fill: "#C2CDDD"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M401.904 277.417L395.531 281.097V265.541L401.904 261.863V277.417Z",
    fill: "#C2CDDD"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M306.099 357.547L299.727 361.226V345.672L306.099 341.992V357.547Z",
    fill: "#C2CDDD"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M409.445 297.878L415.817 294.201V278.645L409.445 282.324V297.878Z",
    fill: "#C2CDDD"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M320.02 349.511L313.648 353.191V337.636L320.02 333.957V349.511Z",
    fill: "#C2CDDD"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M327.692 345.08L321.32 348.757V333.203L327.692 329.523V345.08Z",
    fill: "#C2CDDD"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M335.372 340.648L329 344.327V328.771L335.372 325.094V340.648Z",
    fill: "#C2CDDD"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M353.286 330.304L346.914 333.984V318.428L353.286 314.75V330.304Z",
    fill: "#C2CDDD"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M360.958 325.872L354.586 329.55V313.996L360.958 310.316V325.872Z",
    fill: "#C2CDDD"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M368.638 321.442L362.266 325.12V309.565L368.638 305.887V321.442Z",
    fill: "#C2CDDD"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M386.551 311.097L380.18 314.777V299.22L386.551 295.543V311.097Z",
    fill: "#C2CDDD"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M394.223 306.664L387.852 310.343V294.788L394.223 291.109V306.664Z",
    fill: "#C2CDDD"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M401.904 302.235L395.531 305.913V290.358L401.904 286.68V302.235Z",
    fill: "#C2CDDD"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M306.099 382.361L299.727 386.039V370.484L306.099 366.805V382.361Z",
    fill: "#C2CDDD"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M409.445 322.695L415.817 319.016V303.461L409.445 307.14V322.695Z",
    fill: "#C2CDDD"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M320.02 374.324L313.648 378.004V362.448L320.02 358.77V374.324Z",
    fill: "#C2CDDD"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M327.692 369.895L321.32 373.573V358.017L327.692 354.34V369.895Z",
    fill: "#C2CDDD"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M335.372 365.462L329 369.141V353.586L335.372 349.906V365.462Z",
    fill: "#C2CDDD"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M353.286 355.121L346.914 358.8V343.245L353.286 339.566V355.121Z",
    fill: "#C2CDDD"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M360.958 350.692L354.586 354.37V338.815L360.958 335.137V350.692Z",
    fill: "#C2CDDD"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M368.638 346.258L362.266 349.938V334.382L368.638 330.703V346.258Z",
    fill: "#C2CDDD"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M386.551 335.914L380.18 339.593V324.038L386.551 320.359V335.914Z",
    fill: "#C2CDDD"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M394.223 331.482L387.852 335.159V319.606L394.223 315.926V331.482Z",
    fill: "#C2CDDD"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M401.904 327.051L395.531 330.731V315.175L401.904 311.496V327.051Z",
    fill: "#C2CDDD"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M306.099 407.18L299.727 410.859V395.304L306.099 391.625V407.18Z",
    fill: "#C2CDDD"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M409.445 347.511L415.817 343.832V328.277L409.445 331.956V347.511Z",
    fill: "#C2CDDD"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M320.02 399.146L313.648 402.825V387.27L320.02 383.59V399.146Z",
    fill: "#C2CDDD"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M327.692 394.711L321.32 398.39V382.835L327.692 379.156V394.711Z",
    fill: "#C2CDDD"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M335.372 390.282L329 393.96V378.405L335.372 374.727V390.282Z",
    fill: "#C2CDDD"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M353.286 379.938L346.914 383.616V368.063L353.286 364.383V379.938Z",
    fill: "#C2CDDD"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M360.958 375.508L354.586 379.187V363.632L360.958 359.953V375.508Z",
    fill: "#C2CDDD"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M368.638 371.076L362.266 374.754V359.199L368.638 355.52V371.076Z",
    fill: "#C2CDDD"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M386.551 360.731L380.18 364.409V348.854L386.551 345.176V360.731Z",
    fill: "#C2CDDD"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M394.223 356.301L387.852 359.98V344.425L394.223 340.746V356.301Z",
    fill: "#C2CDDD"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M401.904 351.869L395.531 355.547V339.992L401.904 336.312V351.869Z",
    fill: "#C2CDDD"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M306.099 431.995L299.727 435.675V420.119L306.099 416.441V431.995Z",
    fill: "#C2CDDD"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M409.445 372.327L415.817 368.648V353.094L409.445 356.772V372.327Z",
    fill: "#C2CDDD"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M320.02 423.957L313.648 427.636V412.081L320.02 408.402V423.957Z",
    fill: "#C2CDDD"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M327.692 419.527L321.32 423.206V407.651L327.692 403.973V419.527Z",
    fill: "#C2CDDD"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M335.372 415.095L329 418.773V403.219L335.372 399.539V415.095Z",
    fill: "#C2CDDD"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M353.286 404.754L346.914 408.433V392.878L353.286 389.199V404.754Z",
    fill: "#C2CDDD"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M360.958 400.323L354.586 404.003V388.447L360.958 384.77V400.323Z",
    fill: "#C2CDDD"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M368.638 395.891L362.266 399.57V384.015L368.638 380.336V395.891Z",
    fill: "#C2CDDD"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M386.551 385.548L380.18 389.226V373.672L386.551 369.992V385.548Z",
    fill: "#C2CDDD"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M394.223 381.116L387.852 384.796V369.24L394.223 365.562V381.116Z",
    fill: "#C2CDDD"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M401.904 376.684L395.531 380.363V364.808L401.904 361.129V376.684Z",
    fill: "#C2CDDD"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M306.099 456.81L299.727 460.489V444.934L306.099 441.254V456.81Z",
    fill: "#C2CDDD"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M409.445 397.144L415.817 393.465V377.91L409.445 381.589V397.144Z",
    fill: "#C2CDDD"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M320.02 448.774L313.648 452.452V436.897L320.02 433.219V448.774Z",
    fill: "#C2CDDD"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M327.692 444.344L321.32 448.023V432.468L327.692 428.789V444.344Z",
    fill: "#C2CDDD"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M335.372 439.913L329 443.593V428.037L335.372 424.359V439.913Z",
    fill: "#C2CDDD"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M353.286 429.568L346.914 433.245V417.69L353.286 414.012V429.568Z",
    fill: "#C2CDDD"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M360.958 425.137L354.586 428.816V413.261L360.958 409.582V425.137Z",
    fill: "#C2CDDD"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M368.638 420.707L362.266 424.386V408.831L368.638 405.152V420.707Z",
    fill: "#C2CDDD"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M386.551 410.364L380.18 414.042V398.487L386.551 394.809V410.364Z",
    fill: "#C2CDDD"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M394.223 405.931L387.852 409.61V394.055L394.223 390.375V405.931Z",
    fill: "#C2CDDD"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M401.904 401.5L395.531 405.179V389.624L401.904 385.945V401.5Z",
    fill: "#C2CDDD"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M292.176 511.177L161 435.442V91.9141L292.176 167.649V511.177Z",
    fill: "#B6CEFB"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M174.918 124.164L168.547 120.486V104.93L174.918 108.609V124.164Z",
    fill: "#F7F8FB"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M278.266 183.832L284.637 187.512V171.957L278.266 168.277V183.832Z",
    fill: "#F7F8FB"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M188.84 132.198L182.469 128.52V112.965L188.84 116.643V132.198Z",
    fill: "#F7F8FB"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M196.512 136.629L190.141 132.95V117.395L196.512 121.074V136.629Z",
    fill: "#F7F8FB"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M204.192 141.062L197.82 137.383V121.828L204.192 125.507V141.062Z",
    fill: "#F7F8FB"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M222.099 151.405L215.727 147.727V132.172L222.099 135.851V151.405Z",
    fill: "#F7F8FB"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M229.771 155.836L223.398 152.158V136.602L229.771 140.281V155.836Z",
    fill: "#F7F8FB"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M237.449 160.269L231.078 156.59V141.035L237.449 144.714V160.269Z",
    fill: "#F7F8FB"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M255.365 170.612L248.992 166.934V151.379L255.365 155.056V170.612Z",
    fill: "#F7F8FB"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M263.035 175.043L256.664 171.365V155.809L263.035 159.488V175.043Z",
    fill: "#F7F8FB"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M270.716 179.476L264.344 175.797V160.242L270.716 163.921V179.476Z",
    fill: "#F7F8FB"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M174.918 148.98L168.547 145.301V129.746L174.918 133.425V148.98Z",
    fill: "#F7F8FB"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M278.266 208.649L284.637 212.327V196.772L278.266 193.094V208.649Z",
    fill: "#F7F8FB"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M188.84 157.015L182.469 153.335V137.781L188.84 141.459V157.015Z",
    fill: "#F7F8FB"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M196.512 161.446L190.141 157.767V142.211L196.512 145.891V161.446Z",
    fill: "#F7F8FB"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M204.192 165.878L197.82 162.2V146.645L204.192 150.323V165.878Z",
    fill: "#F7F8FB"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M222.099 176.222L215.727 172.542V156.988L222.099 160.667V176.222Z",
    fill: "#F7F8FB"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M229.771 180.652L223.398 176.973V161.418L229.771 165.097V180.652Z",
    fill: "#F7F8FB"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M237.449 185.085L231.078 181.407V165.852L237.449 169.53V185.085Z",
    fill: "#F7F8FB"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M255.365 195.429L248.992 191.75V176.195L255.365 179.874V195.429Z",
    fill: "#F7F8FB"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M263.035 199.859L256.664 196.18V180.625L263.035 184.304V199.859Z",
    fill: "#F7F8FB"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M270.716 204.292L264.344 200.612V185.059L270.716 188.736V204.292Z",
    fill: "#F7F8FB"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M174.918 173.796L168.547 170.119V154.562L174.918 158.242V173.796Z",
    fill: "#F7F8FB"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M278.266 233.466L284.637 237.144V221.59L278.266 217.91V233.466Z",
    fill: "#F7F8FB"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M188.84 181.831L182.469 178.153V162.598L188.84 166.276V181.831Z",
    fill: "#F7F8FB"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M196.512 186.261L190.141 182.582V167.027L196.512 170.707V186.261Z",
    fill: "#F7F8FB"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M204.192 190.695L197.82 187.015V171.461L204.192 175.138V190.695Z",
    fill: "#F7F8FB"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M222.099 201.039L215.727 197.36V181.805L222.099 185.483V201.039Z",
    fill: "#F7F8FB"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M229.771 205.468L223.398 201.79V186.234L229.771 189.914V205.468Z",
    fill: "#F7F8FB"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M237.449 209.902L231.078 206.222V190.668L237.449 194.347V209.902Z",
    fill: "#F7F8FB"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M255.365 220.246L248.992 216.567V201.012L255.365 204.69V220.246Z",
    fill: "#F7F8FB"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M263.035 224.675L256.664 220.998V205.441L263.035 209.121V224.675Z",
    fill: "#F7F8FB"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M270.716 229.109L264.344 225.43V209.875L270.716 213.554V229.109Z",
    fill: "#F7F8FB"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M174.918 198.613L168.547 194.934V179.379L174.918 183.058V198.613Z",
    fill: "#F7F8FB"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M278.266 258.282L284.637 261.96V246.405L278.266 242.727V258.282Z",
    fill: "#F7F8FB"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M188.84 206.649L182.469 202.969V187.414L188.84 191.093V206.649Z",
    fill: "#F7F8FB"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M196.512 211.081L190.141 207.403V191.848L196.512 195.525V211.081Z",
    fill: "#F7F8FB"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M204.192 215.511L197.82 211.832V196.277L204.192 199.956V215.511Z",
    fill: "#F7F8FB"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M222.099 225.856L215.727 222.176V206.621L222.099 210.301V225.856Z",
    fill: "#F7F8FB"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M229.771 230.288L223.398 226.61V211.055L229.771 214.733V230.288Z",
    fill: "#F7F8FB"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M237.449 234.718L231.078 231.039V215.484L237.449 219.163V234.718Z",
    fill: "#F7F8FB"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M255.365 245.058L248.992 241.38V225.824L255.365 229.504V245.058Z",
    fill: "#F7F8FB"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M263.035 249.491L256.664 245.813V230.258L263.035 233.936V249.491Z",
    fill: "#F7F8FB"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M270.716 253.921L264.344 250.242V234.688L270.716 238.366V253.921Z",
    fill: "#F7F8FB"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M174.918 223.429L168.547 219.749V204.195L174.918 207.873V223.429Z",
    fill: "#F7F8FB"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M278.266 283.094L284.637 286.773V271.218L278.266 267.539V283.094Z",
    fill: "#F7F8FB"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M188.84 231.464L182.469 227.787V212.23L188.84 215.91V231.464Z",
    fill: "#F7F8FB"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M196.512 235.898L190.141 232.219V216.664L196.512 220.343V235.898Z",
    fill: "#F7F8FB"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M204.192 240.327L197.82 236.649V221.094L204.192 224.773V240.327Z",
    fill: "#F7F8FB"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M222.099 250.671L215.727 246.992V231.438L222.099 235.116V250.671Z",
    fill: "#F7F8FB"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M229.771 255.101L223.398 251.422V235.867L229.771 239.546V255.101Z",
    fill: "#F7F8FB"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M237.449 259.534L231.078 255.857V240.301L237.449 243.981V259.534Z",
    fill: "#F7F8FB"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M255.365 269.874L248.992 266.196V250.641L255.365 254.319V269.874Z",
    fill: "#F7F8FB"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M263.035 274.308L256.664 270.628V255.074L263.035 258.752V274.308Z",
    fill: "#F7F8FB"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M270.716 278.738L264.344 275.06V259.504L270.716 263.184V278.738Z",
    fill: "#F7F8FB"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M174.918 248.245L168.547 244.567V229.012L174.918 232.69V248.245Z",
    fill: "#F7F8FB"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M278.266 307.913L284.637 311.593V296.037L278.266 292.359V307.913Z",
    fill: "#F7F8FB"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M188.84 256.28L182.469 252.602V237.047L188.84 240.726V256.28Z",
    fill: "#F7F8FB"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M196.512 260.714L190.141 257.034V241.48L196.512 245.158V260.714Z",
    fill: "#F7F8FB"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M204.192 265.145L197.82 261.466V245.91L204.192 249.59V265.145Z",
    fill: "#F7F8FB"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M222.099 275.488L215.727 271.81V256.254L222.099 259.933V275.488Z",
    fill: "#F7F8FB"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M229.771 279.921L223.398 276.241V260.688L229.771 264.366V279.921Z",
    fill: "#F7F8FB"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M237.449 284.351L231.078 280.672V265.117L237.449 268.796V284.351Z",
    fill: "#F7F8FB"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M255.365 294.691L248.992 291.012V275.457L255.365 279.136V294.691Z",
    fill: "#F7F8FB"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M263.035 299.121L256.664 295.443V279.887L263.035 283.566V299.121Z",
    fill: "#F7F8FB"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M270.716 303.554L264.344 299.875V284.32L270.716 287.999V303.554Z",
    fill: "#F7F8FB"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M174.918 273.062L168.547 269.383V253.828L174.918 257.507V273.062Z",
    fill: "#F7F8FB"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M278.266 332.731L284.637 336.409V320.854L278.266 317.176V332.731Z",
    fill: "#F7F8FB"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M188.84 281.097L182.469 277.417V261.863L188.84 265.541V281.097Z",
    fill: "#F7F8FB"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M196.512 285.528L190.141 281.849V266.293L196.512 269.973V285.528Z",
    fill: "#F7F8FB"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M204.192 289.96L197.82 286.282V270.727L204.192 274.405V289.96Z",
    fill: "#F7F8FB"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M222.099 300.304L215.727 296.624V281.07L222.099 284.748V300.304Z",
    fill: "#F7F8FB"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M229.771 304.735L223.398 301.056V285.5L229.771 289.18V304.735Z",
    fill: "#F7F8FB"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M237.449 309.167L231.078 305.489V289.934L237.449 293.612V309.167Z",
    fill: "#F7F8FB"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M255.365 319.511L248.992 315.832V300.277L255.365 303.956V319.511Z",
    fill: "#F7F8FB"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M263.035 323.941L256.664 320.262V304.707L263.035 308.386V323.941Z",
    fill: "#F7F8FB"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M270.716 328.375L264.344 324.696V309.141L270.716 312.819V328.375Z",
    fill: "#F7F8FB"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M174.918 297.878L168.547 294.201V278.645L174.918 282.324V297.878Z",
    fill: "#F7F8FB"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M278.266 357.547L284.637 361.226V345.672L278.266 341.992V357.547Z",
    fill: "#F7F8FB"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M188.84 305.913L182.469 302.235V286.68L188.84 290.358V305.913Z",
    fill: "#F7F8FB"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M196.512 310.343L190.141 306.664V291.109L196.512 294.788V310.343Z",
    fill: "#F7F8FB"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M204.192 314.777L197.82 311.097V295.543L204.192 299.22V314.777Z",
    fill: "#F7F8FB"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M222.099 325.12L215.727 321.442V305.887L222.099 309.565V325.12Z",
    fill: "#F7F8FB"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M229.771 329.55L223.398 325.872V310.316L229.771 313.996V329.55Z",
    fill: "#F7F8FB"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M237.449 333.984L231.078 330.304V314.75L237.449 318.428V333.984Z",
    fill: "#F7F8FB"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M255.365 344.327L248.992 340.648V325.094L255.365 328.771V344.327Z",
    fill: "#F7F8FB"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M263.035 348.757L256.664 345.08V329.523L263.035 333.203V348.757Z",
    fill: "#F7F8FB"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M270.716 353.191L264.344 349.511V333.957L270.716 337.636V353.191Z",
    fill: "#F7F8FB"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M174.918 322.695L168.547 319.016V303.461L174.918 307.14V322.695Z",
    fill: "#F7F8FB"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M278.266 382.361L284.637 386.039V370.484L278.266 366.805V382.361Z",
    fill: "#F7F8FB"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M188.84 330.731L182.469 327.051V311.496L188.84 315.175V330.731Z",
    fill: "#F7F8FB"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M196.512 335.159L190.141 331.482V315.926L196.512 319.606V335.159Z",
    fill: "#F7F8FB"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M204.192 339.593L197.82 335.914V320.359L204.192 324.038V339.593Z",
    fill: "#F7F8FB"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M222.099 349.938L215.727 346.258V330.703L222.099 334.382V349.938Z",
    fill: "#F7F8FB"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M229.771 354.37L223.398 350.692V335.137L229.771 338.815V354.37Z",
    fill: "#F7F8FB"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M237.449 358.8L231.078 355.121V339.566L237.449 343.245V358.8Z",
    fill: "#F7F8FB"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M255.365 369.141L248.992 365.462V349.906L255.365 353.586V369.141Z",
    fill: "#F7F8FB"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M263.035 373.573L256.664 369.895V354.34L263.035 358.017V373.573Z",
    fill: "#F7F8FB"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M270.716 378.004L264.344 374.324V358.77L270.716 362.448V378.004Z",
    fill: "#F7F8FB"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M174.918 347.511L168.547 343.832V328.277L174.918 331.956V347.511Z",
    fill: "#F7F8FB"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M278.266 407.18L284.637 410.859V395.304L278.266 391.625V407.18Z",
    fill: "#F7F8FB"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M188.84 355.547L182.469 351.869V336.312L188.84 339.992V355.547Z",
    fill: "#F7F8FB"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M196.512 359.98L190.141 356.301V340.746L196.512 344.425V359.98Z",
    fill: "#F7F8FB"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M204.192 364.409L197.82 360.731V345.176L204.192 348.854V364.409Z",
    fill: "#F7F8FB"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M222.099 374.754L215.727 371.076V355.52L222.099 359.199V374.754Z",
    fill: "#F7F8FB"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M229.771 379.187L223.398 375.508V359.953L229.771 363.632V379.187Z",
    fill: "#F7F8FB"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M237.449 383.616L231.078 379.938V364.383L237.449 368.063V383.616Z",
    fill: "#F7F8FB"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M255.365 393.96L248.992 390.282V374.727L255.365 378.405V393.96Z",
    fill: "#F7F8FB"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M263.035 398.39L256.664 394.711V379.156L263.035 382.835V398.39Z",
    fill: "#F7F8FB"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M270.716 402.825L264.344 399.146V383.59L270.716 387.27V402.825Z",
    fill: "#F7F8FB"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M174.918 372.327L168.547 368.648V353.094L174.918 356.772V372.327Z",
    fill: "#F7F8FB"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M278.266 431.995L284.637 435.675V420.119L278.266 416.441V431.995Z",
    fill: "#F7F8FB"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M188.84 380.363L182.469 376.684V361.129L188.84 364.808V380.363Z",
    fill: "#F7F8FB"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M196.512 384.796L190.141 381.116V365.562L196.512 369.24V384.796Z",
    fill: "#F7F8FB"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M204.192 389.226L197.82 385.548V369.992L204.192 373.672V389.226Z",
    fill: "#F7F8FB"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M222.099 399.57L215.727 395.891V380.336L222.099 384.015V399.57Z",
    fill: "#F7F8FB"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M229.771 404.003L223.398 400.323V384.77L229.771 388.447V404.003Z",
    fill: "#F7F8FB"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M237.449 408.433L231.078 404.754V389.199L237.449 392.878V408.433Z",
    fill: "#F7F8FB"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M255.365 418.773L248.992 415.095V399.539L255.365 403.219V418.773Z",
    fill: "#F7F8FB"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M263.035 423.206L256.664 419.527V403.973L263.035 407.651V423.206Z",
    fill: "#F7F8FB"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M270.716 427.636L264.344 423.957V408.402L270.716 412.081V427.636Z",
    fill: "#F7F8FB"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M174.918 397.144L168.547 393.465V377.91L174.918 381.589V397.144Z",
    fill: "#F7F8FB"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M278.266 456.81L284.637 460.489V444.934L278.266 441.254V456.81Z",
    fill: "#F7F8FB"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M188.84 405.179L182.469 401.5V385.945L188.84 389.624V405.179Z",
    fill: "#F7F8FB"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M196.512 409.61L190.141 405.931V390.375L196.512 394.055V409.61Z",
    fill: "#F7F8FB"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M204.192 414.042L197.82 410.364V394.809L204.192 398.487V414.042Z",
    fill: "#F7F8FB"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M222.099 424.386L215.727 420.707V405.152L222.099 408.831V424.386Z",
    fill: "#F7F8FB"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M229.771 428.816L223.398 425.137V409.582L229.771 413.261V428.816Z",
    fill: "#F7F8FB"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M237.449 433.245L231.078 429.568V414.012L237.449 417.69V433.245Z",
    fill: "#F7F8FB"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M255.365 443.593L248.992 439.913V424.359L255.365 428.037V443.593Z",
    fill: "#F7F8FB"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M263.035 448.023L256.664 444.344V428.789L263.035 432.468V448.023Z",
    fill: "#F7F8FB"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M270.716 452.452L264.344 448.774V433.219L270.716 436.897V452.452Z",
    fill: "#F7F8FB"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M225.521 472.693L212.102 464.945V436.707L225.521 444.454V472.693Z",
    fill: "#0047CC"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M241.076 481.674L227.656 473.927V445.688L241.076 453.435V481.674Z",
    fill: "#0047CC"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M423.347 91.9183L292.171 16.1836L161 91.9149L292.176 167.65L423.347 91.9183Z",
    fill: "#85AFFB"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M401.865 91.9514L394.15 96.3944L292.185 37.5308L190.136 96.3944L182.422 91.9514L292.185 28.5586L401.865 91.9514Z",
    fill: "#B6CEFB"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M354.573 96.1745L292.172 132.202V122.309L354.573 86.2812V96.1745Z",
    fill: "#003EB3"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M292.175 132.202L229.773 96.1745V86.2812L292.175 122.309V132.202Z",
    fill: "#0047CC"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M354.576 86.2814L292.174 50.2539L229.773 86.2803L292.176 122.309L354.576 86.2814Z",
    fill: "#5C93F8"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M333.595 86.6914L292.172 110.608V81.1337L333.595 57.2188V86.6914Z",
    fill: "#003EB3"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M292.173 110.608L250.75 86.6914V57.2188L292.173 81.1337V110.608Z",
    fill: "#0047CC"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M333.593 57.2197L292.171 33.3047L250.75 57.2197L292.173 81.1347L333.593 57.2197Z",
    fill: "#5C93F8"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M308.756 55.3247L292.18 64.8968V26.7049L308.756 17.1328V55.3247Z",
    fill: "#003EB3"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M292.178 64.8968L275.602 55.3247V17.1328L292.178 26.7049V64.8968Z",
    fill: "#0047CC"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M308.755 17.1334L292.178 7.5625L275.602 17.1323L292.178 26.7043L308.755 17.1334Z",
    fill: "#5C93F8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrande);
export default __webpack_public_path__ + "static/media/grande.ffe69a22515cb10c7d4f1c9fe0516cf1.svg";
export { ForwardRef as ReactComponent };